<template>
  <div  v-if="render">
        <VueSlickCarousel v-bind="settings" class="main-banner" >
             <div v-for="(item,index) in banner" :key="index" class="d-inline-block"  >
               <a :href="item.url"  target="_blank">
                 <img  :src="$vuetify.breakpoint.smAndDown ? http + item.mobile_img : http + item.desktop_img" >
               </a>
             </div>
              <template #customPaging="page">
                <button type="button">
                  {{page +1}}
                </button>
              </template>
        </VueSlickCarousel>
  </div>
</template>
<script>
    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    import {domain} from "../services/Constants";
    export default {
        name: "multiBanner",
        components: {VueSlickCarousel},
        data() {
            return {
                http: domain,
                render: false,
                settings: {
                    adaptiveHeight: true,
                    arrows: false,
                    dots: true,
                    autoplaySpeed:3000
                },
            }
        },
        props:{
            banner:{
                type:Array
            }
        },
      async  created(){
        // console.log('bannerxx',this.banner)
        // console.log('typebannerxx',typeof (this.banner))
        setTimeout(() => this.render = true, 2000);
        },

    };
</script>
<style lang="scss">
    .main-banner {
        img {
            width: 100%;
            height: auto;
          //object-fit: fill;
          max-height: 90vh;
        }
      max-height: 100vh;

    }
    .slick-dots {
        position: absolute;
        //left: 2rem;
        bottom: 0.3rem;
        display: block;
        padding: 0;
        margin: 0;
        text-align: left;
        list-style-type: none;

        li.slick-active button {
            background-color: #ff5100;
        }

    }
    .slick-dots li{
        width: 4rem;
        height: 4rem;
        //content: none;
        //margin: 0 1rem 0 0;
    }
    @media (max-width: 46.24em) {
      .slick-dots {
        bottom: 0.6rem;
        left: -1rem;
      }
      .slick-dots li{
        width: 1.5rem;
        height: 1.5rem;
      }
        .slick-dots button {
            --button-size: 32px;
            --button-font-size: 0.8rem;
        }
      .slick-dots li button {
        width: 2rem !important;
        height: 2rem!important;
        --button-size: 0.25px;
        --button-font-size: 0.25rem;
      }
    }
    @media (max-width: 90em) {
        .slick-dots button {
            --button-size: 48px;
            --button-font-size: 1rem;
        }
    }


    .slick-dots li button {
      //--button-size: 1.25px;
      //--button-font-size: 1.25rem;
        width: 3rem;
        height: 3rem;
        padding: 0;
        color: white;
        font-weight: bold;
        font-size: 1.25rem;
        border: none;
        border-radius: 100%;
        background-color: black;
    }
    .slick-dots li button:before{
        content: none;
    }
</style>
